import React from "react";
import { useCase } from "../../../../contexts/CaseContext";
import { Subheading } from "../../../../design/heading";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../design/table";
import moment from "moment";
import VisitStatusBadge from "../../../../components/VisitStatusBadge";
import CreateVisitButton from "../../../../components/CreateVisitButton";

interface Props {
  caseId: string;
}

const CaseDetailEventList: React.FC<Props> = ({ caseId }) => {
  const { visits } = useCase();
  return (
    <>
      <div className="flex flex-wrap items-center justify-between w-full">
        <Subheading>Visits</Subheading>
        <div className="flex gap-4">
          <CreateVisitButton caseId={caseId} />
        </div>
      </div>
      {visits.length === 0 && (
        <div className="py-8 text-center">
          <p className="text-sm text-zinc-500 dark:text-zinc-400">No visits have been scheduled yet.</p>
        </div>
      )}
      {visits.length > 0 && (
        <Table className="mt-4 [--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
          <TableHead>
            <TableRow>
              <TableHeader>Monitor</TableHeader>
              <TableHeader>Start Date</TableHeader>
              <TableHeader>End Date</TableHeader>
              <TableHeader>Status</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {visits.map((visit) => (
              <TableRow
                key={visit.id}
                title={`Visit #${visit.id}`}
                href={`/visit/${visit.id}`}
              >
                <TableCell>
                  {visit.supervisor
                    ? `${visit.supervisor.firstName} ${visit.supervisor.lastName}`
                    : "—"}
                </TableCell>
                <TableCell>
                  {moment(visit.startDate.toDate()).format("lll")}
                </TableCell>
                <TableCell>
                  {moment(visit.endDate.toDate()).format("lll")}
                </TableCell>
                <TableCell>
                  <VisitStatusBadge status={visit.status} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default CaseDetailEventList;
